import React, { Component } from 'react';
import Accordion from 'travco-accordion';
import Select from 'react-select';
import InputRange from 'react-input-range';

export default class SearchResultsFilter extends Component {
    render() {
        const {
            isSearchTriggered,
            isLoading,
            budget,
            starRating,
            offers,
            info,
            availableHotelAmenities,
            availableRoomAmenities,
            availableRoomCategory,
            availableBoardBasis,
            hotelAmenitiesValue,
            roomAmenitiesValue,
            roomCategoryValue,
            boardBasisValue,
            budgetMax,
            currencyFormat,
            currencyName,
            onBudgetChange,
            onRangeNumbersChange,
            onDropdownChange,
            onInfoChange,
            onStarRatingChange,
            onOffersChange
        } = this.props;
        return (
            <div className="travco-search-filters-wrapper">
                <h3 className="ts-f-title">Filters</h3>

                <Accordion allowMultipleOpen>
                    {[
                        <div className="ts-f-fieldset" label="Price" ref="ts-f-price" isOpen>
                            <div className="ts-f-option-field">
                                <label>
                                    Budget ({currencyName})
                                </label>
                                <InputRange
                                    type="checkbox"
                                    name="budget"
                                    id="ts-f-budget"
                                    step={50}
                                    maxValue={budgetMax}
                                    formatLabel={value => ''}
                                    minValue={0}
                                    value={budget}
                                    onChangeComplete={onBudgetChange.bind(this)}
                                    onChange={onRangeNumbersChange.bind(this)}
                                    disabled={!isSearchTriggered || isLoading}
                                />
                                <span>{currencyFormat(budget.min)}</span>
                                <span style={{float:'right'}}>{currencyFormat(budget.max)}</span>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="isNonRefundable"
                                        id="ts-f-isNonRefundable"
                                        checked={info.has('isNonRefundable')}
                                        onChange={onInfoChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Refundable Only</span>
                                </label>
                            </div>
                        </div>,
                        <div className="ts-f-fieldset" label="Offers" ref="ts-f-offers" isOpen>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="specialOffer"
                                        id="ts-f-specialOffer"
                                        checked={offers.has('specialOffer')}
                                        onChange={onOffersChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>All Offers</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="advancedBooking"
                                        id="ts-f-earlyBird"
                                        checked={offers.has('advancedBooking') || offers.has('specialOffer')}
                                        onChange={onOffersChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Early Bird</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="freeNights"
                                        id="ts-f-freeNights"
                                        checked={offers.has('freeNights') || offers.has('specialOffer')}
                                        onChange={onOffersChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Free Nights</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="minLength"
                                        id="ts-f-minLength"
                                        checked={offers.has('minLength') || offers.has('specialOffer')}
                                        onChange={onOffersChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Minimum Night Stay</span>
                                </label>
                            </div>
                        </div>,
                        <div className="ts-f-fieldset" label="Rating" ref="ts-f-rating" isOpen>
                            <div className="ts-f-option-field">
                                <label>
                                    Star Rating
                                </label>
                                <div className="ts-f-option-field">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="1Star"
                                            id="ts-f-1star"
                                            checked={starRating.has('1Star')}
                                            onChange={onStarRatingChange.bind(this)}
                                            disabled={!isSearchTriggered || isLoading}
                                        />
                                        <span>1 Star</span>
                                    </label>
                                </div>
                                <div className="ts-f-option-field">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="2Stars"
                                            id="ts-f-2star"
                                            checked={starRating.has('2Stars')}
                                            onChange={onStarRatingChange.bind(this)}
                                            disabled={!isSearchTriggered || isLoading}
                                        />
                                        <span>2 Stars</span>
                                    </label>
                                </div>
                                <div className="ts-f-option-field">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="3Stars"
                                            id="ts-f-3star"
                                            checked={starRating.has('3Stars')}
                                            onChange={onStarRatingChange.bind(this)}
                                            disabled={!isSearchTriggered || isLoading}
                                        />
                                        <span>3 Stars</span>
                                    </label>
                                </div>
                                <div className="ts-f-option-field">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="4Stars"
                                            id="ts-f-4star"
                                            checked={starRating.has('4Stars')}
                                            onChange={onStarRatingChange.bind(this)}
                                            disabled={!isSearchTriggered || isLoading}
                                        />
                                        <span>4 Stars</span>
                                    </label>
                                </div>
                                <div className="ts-f-option-field">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="5Stars"
                                            id="ts-f-5star"
                                            checked={starRating.has('5Stars')}
                                            onChange={onStarRatingChange.bind(this)}
                                            disabled={!isSearchTriggered || isLoading}
                                        />
                                        <span>5 Stars</span>
                                    </label>
                                </div>
                            </div>
                        </div>,
                        <div className="ts-f-fieldset" label="Hotel" ref="ts-f-hotelInfo" isOpen>
                            <div className="ts-f-option-field">
                                <label>
                                    Hotel Amenities
                                </label>
                                <Select
                                    value={hotelAmenitiesValue}
                                    options={availableHotelAmenities}
                                    onChange={onDropdownChange.bind(this)}
                                    name="hotelAmenities"
                                    isMulti
                                    isClearable
                                    isSearchable
                                    closeMenuOnSelect={false}
                                    isDisabled={!isSearchTriggered || isLoading}
                                />
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="webSite"
                                        id="ts-f-webSite"
                                        checked={info.has('webSite')}
                                        onChange={onInfoChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Webpage</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="primaryPhone"
                                        id="ts-f-telephone"
                                        checked={info.has('primaryPhone')}
                                        onChange={onInfoChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Telephone</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="primaryFax"
                                        id="ts-f-fax"
                                        checked={info.has('primaryFax')}
                                        onChange={onInfoChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Fax</span>
                                </label>
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="email"
                                        id="ts-f-email"
                                        checked={info.has('email')}
                                        onChange={onInfoChange.bind(this)}
                                        disabled={!isSearchTriggered || isLoading}
                                    />
                                    <span>Email</span>
                                </label>
                            </div>
                        </div>,
                        <div className="ts-f-fieldset" label="Room" ref="ts-f-roomInfo" isOpen>
                            <div className="ts-f-option-field">
                                <label>Room Amenities</label>
                                <Select
                                    value={roomAmenitiesValue}
                                    options={availableRoomAmenities}
                                    onChange={onDropdownChange.bind(this)}
                                    name="roomAmenities"
                                    isMulti
                                    isClearable
                                    isSearchable
                                    closeMenuOnSelect={false}
                                    isDisabled={!isSearchTriggered || isLoading}
                                />
                            </div>
                            <div className="ts-f-option-field">
                                <label>Category</label>
                                <Select
                                    value={roomCategoryValue}
                                    options={availableRoomCategory}
                                    onChange={onDropdownChange.bind(this)}
                                    name="roomCategory"
                                    isClearable
                                    isSearchable
                                    isDisabled={!isSearchTriggered || isLoading}
                                />
                            </div>
                            <div className="ts-f-option-field">
                                <label>
                                    Board Basis
                                </label>
                                <Select
                                    value={boardBasisValue}
                                    options={availableBoardBasis}
                                    onChange={onDropdownChange.bind(this)}
                                    name="boardBasis"
                                    isClearable
                                    isSearchable
                                    isDisabled={!isSearchTriggered || isLoading}
                                />
                            </div>
                        </div>
                    ]}
                </Accordion>
            </div>
        );
    }
}
